"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kansaResultReducer = exports.kansaResultActions = exports.TYPES = exports.PROC_KBN = exports.INIT_STATE = exports.CONTENTS = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Result';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  FIX_CONDITIONS: PREFIX + 'fixCondtions',
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  GO_MAIN: PREFIX + 'GoMain',
  RESET_PAGING: PREFIX + 'ResetPaging',
  CHANGE_PAGE: PREFIX + 'ChangePage',
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  SET_SHITEKI_LIST: PREFIX + 'SetShitekiList',
  SET_SHITEKI_ENTRIES_LIST: PREFIX + 'SetShitekiEntriesList',
  SET_CONTENT: PREFIX + 'SetContent',
  SET_KANSA_INFO: PREFIX + 'SetKansaInfo',
  SET_TEST: PREFIX + 'SetTest',
  SET_ENTRY: PREFIX + 'SetEntry',
  SET_ENTRIES: PREFIX + 'SetEntries',
  CLEAR: PREFIX + 'Clear',
  // 年度選択変更
  CHANGE_NENDO: PREFIX + 'ChangeNendo',
  INIT_NENDO: PREFIX + 'initNendo',
  // 初期値を返却
  PREPARATION_MESSAGE: PREFIX + 'SetInitialValue',
  // 利用許可
  SET_PERMISSION: PREFIX + 'SetPermission',
  SET_KANSA_TGT_JIGYO_BASIC_INFO: PREFIX + 'SetKansaTgtJigyoBasicInfo',
  CHANGE_PUSH_SWITCH_FLG: PREFIX + 'ChangePushSwitchFlg',
  CHANGE_PUSH_FLG: PREFIX + 'ChangePushFlg',
  SET_MAIL_ERR_MSG: PREFIX + 'SetMailErrMsg',
  // 共有検索条件設定
  APPLY_SHARE_CONDITION: PREFIX + 'ApplyShareCondtion'
};

/**
 * コンテンツタイプ
 */
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  RESULT_REFER: 'ResultRefer',
  RESULT_REFER_OLD: 'ResultReferOld',
  RESULT_REGISTER: 'ResultRegister',
  RESULT_UPDATE: 'ResultUpdate',
  SHITEKI_REFER: 'ShitekiRefer',
  SHITEKI_REGISTER: 'ShitekiRegister',
  SHITEKI_UPDATE: 'ShitekiUpdate',
  HYOKA_REFER: 'HyokaRefer',
  HYOKA_REGISTER: 'HyokaRegister',
  HYOKA_UPDATE: 'HyokaUpdate',
  SHITEKI_ENTRY: 'shitekiEntry',
  SHITEKI_RESULT: 'shitekiResult',
  SHITEKI_DETAIL: 'shitekiDetail',
  SHITEKI_OLD_DETAIL: 'shitekiOldDetail',
  TANTOSHA_HYOKA: 'tantoshaHyoka',
  HIKANSA_ENTRY: 'hikansaEntry',
  HIKANSA_RESULT: 'hikansaResult',
  HIKANSA_DETAIL: 'hikansaDetail',
  PROGRESS_TO_RESULT_REFER: 'progressToResultRefer',
  // 監査進捗状況：監査結果表示
  PROGRESS_TO_RESULT_REFER_OLD: 'progressToResultReferOld',
  // 監査進捗状況：監査結果表示（詳細版）
  PROGRESS_TO_RESULT_REGISTER: 'progressToResultRegister',
  // 監査進捗状況：監査結果登録
  PROGRESS_TO_RESULT_UPDATE: 'progressToResultUpdate',
  // 監査進捗状況：監査結果更新
  PROGRESS_TO_SHITEKI_REFER: 'progressToShitekiRefer',
  // 監査進捗状況：指摘事項改善・実績表示
  PROGRESS_TO_SHITEKI_REFER_OLD: 'progressToShitekiReferOld',
  // 監査進捗状況：指摘事項改善・実績表示（詳細版）
  PROGRESS_TO_SHITEKI_REGISTER: 'progressToShitekiRegister',
  // 監査進捗状況：指摘事項改善・実績登録
  PROGRESS_TO_HYOKA_REFER: 'progressToHyokaRefer',
  // 監査進捗状況：被監査部門責任者評価表示
  PROGRESS_TO_HYOKA_REGISTER: 'progressToHyokaRegister' // 監査進捗状況：被監査部門責任者評価登録
};

// 検索項目（初期値）
const INIT_CONDITION = Object.freeze({
  gyomuCdAvail: _CodeConsts.CODE.AUTH_GYOMU_CD.CODE_3,
  // 権限制御業務内容コード
  gyomuCd: _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1,
  //業務内容
  kansaTgtNendo: '',
  //監査対象年度
  kansaTgtJigyoId: '',
  //監査対象事業Id
  kansaTgtNendoNm: '',
  //監査対象年度ラベル
  kansaThemeNm: '',
  //監査テーマ
  kansaKaishaCd: '',
  //監査部門 会社コード
  kansaBumonCd: '',
  //監査部門 組織コード
  kansaBumonNm: '',
  //監査部門名
  hikansaKaishaCd: '',
  //被監査部門 会社コード
  hikansaBumonCd: '',
  //被監査部門 組織コード
  hikansaBumonNm: '',
  //被監査部門名
  kansaTgtJigyoNm: '',
  //監査対象事業名
  tantoOnlyFlg: false,
  //担当の監査対象事業のみ表示
  kansaSts: _CodeConsts.CODE.KANSA_STS.CODE_0,
  //監査状況
  kaitoSts: _CodeConsts.CODE.KANSA_ANS_STS.CODE_0,
  //監査回答状況
  makeSts: _CodeConsts.CODE.KANSA_RSLT_STS.CODE_0,
  //監査結果作成状況
  planSts: _CodeConsts.CODE.KANSA_KZPLN_STS.CODE_4,
  //指摘事項改善 計画状況
  progSts: _CodeConsts.CODE.KANSA_KZPRG_STS.CODE_4,
  //指摘事項改善 進捗状況
  evalSts: _CodeConsts.CODE.KANSA_HYOKA_STS.CODE_0 //被監査部門責任者評価評価状況
});

/**
 * ボタンタイプ
 */
const PROC_KBN = exports.PROC_KBN = {
  TMP_SAVE: 'temp_save',
  REGISTER: 'register'
};

/**
 * 初期State
 */
const INIT_STATE = exports.INIT_STATE = {
  dispContent: CONTENTS.MAIN,
  // 初期値はメインとする
  isProgress: false,
  previousView: '',
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  },
  soshikiShowAll: false,
  searchConditions: _objectSpread({}, INIT_CONDITION),
  fixedConditions: _objectSpread({}, INIT_CONDITION),
  searchResult: [],
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  search: false,
  shitekiList: [],
  shitekiEntriesList: [],
  entranceContent: CONTENTS.MAIN,
  entries: {
    kinyuDate: '',
    kansaTgtNendo: '',
    kansaTgtJigyoId: '',
    kinyushaNm: '',
    hikansabumonChiefComment: '',
    hikansabumonChiefHyokaStsCd: '',
    kaizenprogressStsCd: ''
  },
  kansaInfo: {
    kansaTgtNendo: '',
    kansaTgtJigyoId: ''
  },
  kansaTgtJigyoBasicInfo: {
    kansaTgtNendoNm: '',
    kansaThemeNm: '',
    kansaBumonNm: '',
    kansaSekinishaNm: '',
    kansaTgtJigyoNm: '',
    hikansaSekinishaNm: ''
  },
  pushSwitchFlg: false,
  pushFlg: true,
  mailErrMsg: ''
};

/**
 * アクション定義
 */
const kansaResultActions = exports.kansaResultActions = (0, _reduxActions.createActions)({
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_MAIN]: function () {
    return {
      search: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SHITEKI_LIST]: function () {
    return {
      shitekiList: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SHITEKI_ENTRIES_LIST]: function () {
    return {
      no: arguments.length <= 0 ? undefined : arguments[0],
      key: arguments.length <= 1 ? undefined : arguments[1],
      value: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_KANSA_INFO]: function () {
    return {
      kansaInfo: arguments.length <= 0 ? undefined : arguments[0],
      dispContent: arguments.length <= 1 ? undefined : arguments[1],
      isProgress: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  // 年度選択変更
  [TYPES.CHANGE_NENDO]: function () {
    return {
      selectNendo: arguments.length <= 0 ? undefined : arguments[0],
      selectThemeNm: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 初期値を返却
  [TYPES.INIT_NENDO]: function () {
    return {
      selectNendo: arguments.length <= 0 ? undefined : arguments[0],
      selectThemeNm: arguments.length <= 1 ? undefined : arguments[1],
      preparation: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.PREPARATION_MESSAGE]: function () {
    return {
      selectNendo: arguments.length <= 0 ? undefined : arguments[0],
      selectThemeNm: arguments.length <= 1 ? undefined : arguments[1],
      preparation: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.SET_PERMISSION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      flg: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_KANSA_TGT_JIGYO_BASIC_INFO]: function () {
    return {
      kansaTgtJigyoBasicInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PUSH_SWITCH_FLG]: function () {
    return {
      flg: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PUSH_FLG]: function () {
    return {
      flg: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_MAIL_ERR_MSG]: function () {
    return {
      mailErrMsg: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.APPLY_SHARE_CONDITION]: function () {
    return {
      searchConditions: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.FIX_CONDITIONS, TYPES.RESET_PAGING, TYPES.CLEAR);

/**
 * Reducer定義
 */
const kansaResultReducer = exports.kansaResultReducer = (0, _reduxActions.handleActions)({
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    search: false
  }),
  [TYPES.GO_MAIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread({}, state.searchConditions),
    dispContent: CONTENTS.MAIN,
    search: action.payload.search
  }),
  [TYPES.RESET_PAGING]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: 0,
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    let newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: newSearchResult,
      soshikiShowAll: action.payload.showAll
    });
  },
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  [TYPES.SET_SHITEKI_LIST]: (state, action) => {
    let newListState = {};
    action.payload.shitekiList.forEach(data => {
      newListState[data.shitekijikoKbnCd + data.no] = _objectSpread({}, data);
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      shitekiList: action.payload.shitekiList,
      shitekiEntriesList: newListState
    });
  },
  [TYPES.SET_SHITEKI_ENTRIES_LIST]: (state, action) => {
    let newListState = Object.assign({}, state.shitekiEntriesList);
    newListState[action.payload.no] = _objectSpread(_objectSpread({}, newListState[action.payload.no]), {}, {
      [action.payload.key]: action.payload.value
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      shitekiEntriesList: newListState
    });
  },
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.SET_KANSA_INFO]: (state, action) => {
    const {
      kansaInfo,
      dispContent,
      isProgress
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      kansaInfo,
      dispContent,
      isProgress
    });
  },
  // 年度選択変更
  [TYPES.CHANGE_NENDO]: (state, action) => {
    const {
      selectNendo,
      selectThemeNm
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        kansaTgtNendo: selectNendo,
        kansaThemeNm: selectThemeNm
      })
    });
  },
  // 初期値を返却
  [TYPES.INIT_NENDO]: (state, action) => {
    const {
      selectNendo,
      selectThemeNm
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
        kansaTgtNendo: selectNendo,
        kansaThemeNm: selectThemeNm
      })
    });
  },
  [TYPES.SET_PERMISSION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    permission: {
      [action.payload.key]: action.payload.flg
    }
  }),
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread({}, action.payload.entries)
    });
  },
  [TYPES.SET_KANSA_TGT_JIGYO_BASIC_INFO]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      kansaTgtJigyoBasicInfo: action.payload.kansaTgtJigyoBasicInfo
    });
  },
  [TYPES.CHANGE_PUSH_SWITCH_FLG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      pushSwitchFlg: action.payload.flg
    });
  },
  [TYPES.CHANGE_PUSH_FLG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      pushFlg: action.payload.flg
    });
  },
  [TYPES.SET_MAIL_ERR_MSG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      mailErrMsg: action.payload.mailErrMsg
    });
  },
  [TYPES.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  },
  [TYPES.APPLY_SHARE_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), action.payload.searchConditions)
  })
}, INIT_STATE);